import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { GeneralLedgerAccountsDictionary, GeneralLedgerAccountsDictionaryRecord } from "../types";

type GetGeneralLedgerAccountsResponseData = {
  items: Array<GeneralLedgerAccountsDictionaryRecord>;
};

export const generalLedgerAccountsApi = createApi({
  reducerPath: "@general-ledger-accounts/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60 * 60 * 24,
  endpoints: (builder) => ({
    getGeneralLedgerAccountsDictionary: builder.query<GeneralLedgerAccountsDictionary, void>({
      query: () => ({
        url: "/getGlaCodes",
        method: "GET",
      }),
      transformResponse: (response: GetGeneralLedgerAccountsResponseData) => {
        return response.items.reduce((accumulator, item) => {
          accumulator[item.code] = {
            code: item.code,
            name: item.name,
          };
          return accumulator;
        }, {} as GeneralLedgerAccountsDictionary);
      },
    }),
  }),
});
